var render = function render(){var _vm=this,_c=_vm._self._c;return _c('NcContent',{attrs:{"app-name":"forms"}},[_c('Submit',{attrs:{"form":_vm.form,"public-view":true,"share-hash":_vm.shareHash,"is-logged-in":_vm.isLoggedIn}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }